import { c as _c } from "react/compiler-runtime";
import type { OnboardingRequirementCollectDocument } from '@onefootprint/request-types';
import PhotoCapture from '../../../components/photo-capture/photo-capture';
import type { ReceivedImagePayload } from '../../../types';
const FACE_OUTLINE_RATIO = 0.7;
type CaptureViewProps = {
  title: string;
  requirement: OnboardingRequirementCollectDocument;
  hasBadConnectivity: boolean | undefined;
  autocapture: boolean;
  onComplete: (payload: ReceivedImagePayload) => void;
  onBack: () => void;
  onCameraStuck: () => void;
};
const CaptureView = t0 => {
  const $ = _c(10);
  const {
    title,
    requirement,
    hasBadConnectivity,
    autocapture,
    onComplete,
    onBack,
    onCameraStuck
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = {
      camera: title,
      preview: title
    };
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== autocapture || $[3] !== hasBadConnectivity || $[4] !== onBack || $[5] !== onCameraStuck || $[6] !== onComplete || $[7] !== requirement || $[8] !== t1) {
    t2 = <PhotoCapture autocaptureKind="face" autocapture={autocapture} cameraKind="front" deviceKind="mobile" allowPdf={false} requirement={requirement} hasBadConnectivity={hasBadConnectivity} outlineHeightRatio={FACE_OUTLINE_RATIO} outlineWidthRatio={FACE_OUTLINE_RATIO} title={t1} onComplete={onComplete} onBack={onBack} onCameraStuck={onCameraStuck} />;
    $[2] = autocapture;
    $[3] = hasBadConnectivity;
    $[4] = onBack;
    $[5] = onCameraStuck;
    $[6] = onComplete;
    $[7] = requirement;
    $[8] = t1;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default CaptureView;